import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { SessionService } from '../../../services/session.service';
import { Gasto } from '../../../models/gasto';
import { GastoDetalle } from '../../../models/gasto-detalle';
import { GastoService } from '../../../services/gasto.service';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';
import { Message } from '../../../config/message';
import { Producto } from '../../../models/producto';
import { Proveedor } from '../../../models/proveedor';
import { ProveedorService } from '../../../services/proveedor.service';
import { Bodega } from '../../..//models/bodega';
import { BodegaService } from '../../../services/bodega.service';
import { ProductoService } from '../../../services/producto.service';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { FormaPago } from '../../../models/forma-pago';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { ParametroService } from '../../../services/parametro.service';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Pago } from '../../../models/pago';
import { PagoDetalle } from '../../../models/pago_detalle';
import * as numeral from 'numeral';


import * as moment from 'moment';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { AperturaCajaModalComponent } from '../../modals/apertura-caja-modal/apertura-caja-modal.component';
import { CierreCajaModalComponent } from '../../modals/cierre-caja-modal/cierre-caja-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { Transferencia } from '../../../models/transferencia';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';

@Component({
  selector: 'app-gasto-add',
  templateUrl: './gasto-add.component.html',
  styleUrls: ['./gasto-add.component.css'],
  providers: [
    GastoService,
    ProveedorService,
    BodegaService,
    ProductoService,
    SessionService,
	FormaPagoService,
	CajaService,
	ParametroService,
	AsignacionCajaService,
	ImpuestoPorcentajeService
  ]
})
export class GastoAddComponent implements OnInit {
  public title: String;
	public gasto: Gasto;
	public msgSweet: SweetMessage;
	public msg: Message;
	public vl: Validation;
	public IVA: number;
	public proveedor: Proveedor;
	topPrecios: Array<Gasto> = [];
	gastos: Array<GastoDetalle> = [];
	iva: number;
	validDateEmision: boolean = true;
	validDateCaducidad: boolean = true;
	valid: boolean = false;
	bodegas: Array<Bodega> =[];
	private productos: Array<Producto> = [];
	FormGroup = new Array();
	bsModalRef: BsModalRef;
	public total_pago: number;
	public loading = false;
	public formasPago: Array<FormaPago>;
	//public fpSelected: Array<FPSelected>;
	public cambio: number;
	public cajas: Array<Caja>;
	public caja_id: String;
	public pago: Pago;
	public Mod_FactElec: string;
	public Mod_Inventario: string;
	public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
	public valorefectivo: number;
	public fecha_emision;
	public caja: Caja;
	public asignacion_id: number;
	public parametros: Array<any>
    public iva_id : number;
	public iva_vigente:boolean;
	public iva_porcentaje : any;
	public transferencias: Array<Transferencia>;
	@ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;


  constructor(
    private GastoService: GastoService,
		private proveedorService: ProveedorService,
		private bodegaService: BodegaService,
		private productoService: ProductoService,
		private ss: SessionService,
		public fb: FormBuilder,
		private modalService: BsModalService,
		public formaPagoService: FormaPagoService,
		public cajaService: CajaService,
		private parametroService: ParametroService,
		public asignacionService: AsignacionCajaService,
		public impuestoPorcentajeService: ImpuestoPorcentajeService

  ) { 
    	this.title = "Factura compra";
		this.IVA = 0;
		this.total_pago = 0;
		this.formasPago = [];
		//this.fpSelected = [];
		this.cambio = 0;
		this.cajas = [];
		this.pago = new Pago();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.Mod_Inventario = this.ss.getData("mod_inventario");
		this.cheques = [];
    	this.tarjetas = [];
		this.valorefectivo = 0;
		this.fecha_emision = moment(this.fecha_emision);
		this.caja = new Caja();
		this.asignacion_id = 0;
		this.parametros = [];
        this.iva_id = 0;
		this.iva_vigente = false;
		this.iva_porcentaje = 0;
		this.transferencias = [];
  }

  ngOnInit() {
    //Inicializacion de Objectos
		this.msgSweet = new SweetMessage();
		//Inicializacion de Objectos
		this.msg = new Message();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Precio de Producto
		this.gasto = new Gasto();
		//Inicializacion de objecto de Proveedor
		this.proveedor = new Proveedor();
		//Inicializar Formulario
		this.onForm();
		//inicializar fecha
		//this.onIniDate();
		//
		let p1 = this.getBodegas();
		///let p2 = this.getFormasPago();
		let p2 = this.getParametros();
		let p3 = this.getIVA(129);
		//let p3 = this.getCajas();
		let p4 = this.onAperturaCaja();
		this.loading = true;
		Promise.all([p1,p2,p3,p4]).then(
			res => this.loading = false,
			err => this.loading = false
		);
  }

	//#region funciones de inicializacion
	onForm() {
		this.FormGroup["serie"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
		this.FormGroup["punto_emision"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
		this.FormGroup["secuencial"] = { required: true, min: 1, valid: false, n: 0 };
		this.FormGroup["numero_autorizacion"] = { required: true, max: 50, min: 17, valid: false, n: 0 };
		this.FormGroup["compras"] = { required: true, valid: false, n: 0 };
		this.FormGroup["proveedor_id"] = { required: true, valid: false, n: 0 };
		this.FormGroup["bodega_id"] = { required: true, valid: false, n: 0 };
	}

	//Inicializacion de fecha
	onIniDate(){
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; //January is 0!
		let dia = "";
		let mes = "";

		var yyyy = today.getFullYear();
		dia = "" + dd;
		mes = "" + mm;
		if (dd < 10) {
			dia = "0" + dd;
		}
		if (mm < 10) {
			mes = "0" + mm;
		}
		let today2 = dia + '/' + mes + '/' + yyyy;
		this.gasto.fecha_emision = today2;
	}
  

	getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.recalcularFactura();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}
  
	getBodegas() {
		return new Promise((resolve,reject) => {
			let qs = '?sucursal_id=' + this.ss.getData('sucursal_id');
			this.bodegaService.getAll(qs).subscribe(
				res => {
					if (!res.data.length) {
						this.bodegas = [];
					} else {
						this.bodegas = res.data;
					}
					resolve();
				},
				err => {
					this.bodegas = [];
					reject(err);
				}
			);
		});
	}
  
	getNumeroDocumento(){
		return this.gasto.numero_documento = this.gasto.serie + "-" + this.gasto.punto_emision + "-" + this.gasto.secuencial;
	}

	validTypeMsgModel(campo, model) {

		let length = model.length;
		let temp = this.FormGroup[campo];
		if (temp.required && length == 0) {
			return this.msg.required;
		}
		if (length < temp.min) {
			return this.msg.lengthMin;
		}
		if (length > temp.max) {
			return this.msg.lengthMax;
		}

	}

	onkeyUp(event, campo) {
		if (this.FormGroup[campo].n == 0) {
			if (event.target.value.length > 0) {
				this.FormGroup[campo].n = 1;
			}
		}
	}

	onChangeSelect(event,campo){
			if(this.FormGroup[campo].n == 0){
				this.FormGroup[campo].n = 1;
			}
			if (event.target.value.length > 0) {
				this.FormGroup[campo].valid= true;
			}
			else{
				this.FormGroup[campo].valid=false;
			}
	}

	onValidCamp() {
		let i = 0;
		for (i = 0; i < Object.keys(this.FormGroup).length; i++) {
			var item = Object.keys(this.FormGroup)[i];
			if (!this.FormGroup[item]['valid']) {
				this.valid = true;
				return true;
			}
		}
		this.valid = false;
		return false;
	}
  
  //#region Proveedor
	//Busqueda de proveedor
	onSearchProveedor(event) {
		if( event.keyCode === 13 ){
			if( this.proveedor.dni.toString().trim().length == 0 ){
				this.proveedor = new Proveedor();
				return;
			}else{
				this.proveedorService.getByDni(this.proveedor.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.proveedor = res[0];
						}else{
							this.proveedor = new Proveedor();
							this.openDialogProveedor();
						}
					},
					err => {
						this.loading = false;
						this.openDialogProveedor();
					}
				);
			}
		}
	}

	openDialogProveedor() {
		const initialState = {};
		this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProveedor.take(1).subscribe((value) => {
			this.sendObjectProveedor(value);
		});
	}

	sendObjectProveedor(event) {
		//obtencion del producto que envia el componente producto-modal
		this.proveedor = event;
	}

	isValidForm(){
		if( !this.asignacion_id ){
			return false;
		}
		if( !this.proveedor.id ){
			return false;
		}
		if( !this.gasto.proveedor ){
			return false;
		}
		if( !this.gasto.numero_autorizacion ){
			return false;
		}

		// let productos = this.gastos.filter((c: GastoDetalle) => c.es_servicio);
		let productos = this.gastos.filter((c: GastoDetalle) => c.tipo_producto_id == '2');
		if( !productos.length ){
			if( !this.gasto.bodega_id ){
				return false;
			}
		}
		if( !this.gasto.serie ){
			return false;
		}
		if( !this.gasto.punto_emision ){
			return false;
		}
		if( !this.gasto.secuencial ){
			return false;
		}
		if( !this.vl.validDate(this.fecha_emision.toString()) ){
			return false;
		}
		if( !this.gastos.length ){
			return false;
		}

		let banderaDescripcion = true;
		this.gastos.forEach(element => {
			if(element.descripcion.length<1){
				banderaDescripcion=false;
			}
		});
		if(!banderaDescripcion){
			return false;
		}

		let banderaSubtotal = true;
		this.gastos.forEach(element => {
			if(!(element.subtotal>0)){
				banderaSubtotal=false;
			}
		});
		if(!banderaSubtotal){
			return false;
		}

		if(!this.total_pago){
			return false;
		}

		if( this.total_pago < this.gasto.total ){
			return false;
		}

		this.gastos.forEach(element => {
			if(element.bandera_credito_tributario){
				element.credito_tributario="S";
			}
			else{
				element.credito_tributario="N";
			}
		});

		return true;
	}
	
	addDetalle(){
		let detalle = new GastoDetalle();
		detalle.usuario_id = this.ss.getData('usuario_id');
		detalle.empresa_id = this.ss.getData('empresa_id');
		detalle.sucursal_id = this.ss.getData('sucursal_id');
		detalle.producto_id = null;
		this.gastos.push(detalle);
	}

	onDelete(i) {
		this.gastos.splice(i, 1);
	}

	//#region Validacion de la tabla gasto_detalle
	onKeyUp(event, gasto_detalle: GastoDetalle) {
		gasto_detalle.cantidad = event.target.value;
		this.calcularItem(gasto_detalle.precio_unitario, gasto_detalle);
	}

	onChange(event, gasto_detalle: GastoDetalle) {
		gasto_detalle.precio_unitario = event.target.value;
		this.calcularItem(gasto_detalle.precio_unitario, gasto_detalle);
	}

	calcularItem(precio_unitario: number, gasto_detalle: GastoDetalle) {
		gasto_detalle.precio_unitario = precio_unitario;
		gasto_detalle.subtotal = gasto_detalle.precio_unitario * gasto_detalle.cantidad;
		gasto_detalle.iva = gasto_detalle.subtotal * this.iva;
		gasto_detalle.total = gasto_detalle.subtotal + gasto_detalle.iva;
		//this.calcularFactura();
	}

	recalcularItem(event, gasto_detalle: GastoDetalle){
		gasto_detalle.subtotal = (gasto_detalle.cantidad * gasto_detalle.precio_unitario) - gasto_detalle.desc_valor;
		gasto_detalle.iva = parseFloat(gasto_detalle.subtotal.toString()) * parseFloat(this.IVA.toString());
		this.recalcularFactura();
	}

	recalcularFactura(){
		this.gasto.subtotal_iva12 = 0;
        this.gasto.subtotal_iva0 = 0;
        this.gasto.iva = 0;
		this.gasto.total = 0;
		
		this.gastos.forEach(obj => {
			this.gasto.descripcion = obj.descripcion;
			if( obj.graba_iva ){
                this.gasto.subtotal_iva12 += obj.subtotal;
            }else{
                this.gasto.subtotal_iva0 += obj.subtotal;
            }
		});

		if( this.gasto.desct_valor.toString().trim().length === 0 ){
			this.gasto.desct_valor = 0;
		}
		let desc_valor = parseFloat(this.gasto.desct_valor.toString());
		this.gasto.subtotal = parseFloat(this.gasto.subtotal_iva0.toString()) + parseFloat(this.gasto.subtotal_iva12.toString());
		this.gasto.subtotal = parseFloat(this.gasto.subtotal.toString()) - parseFloat(this.gasto.desct_valor.toString());
		this.gasto.iva = Math.round((this.gasto.subtotal_iva12 * this.IVA) * 100) / 100;
		this.gasto.total = this.gasto.subtotal + this.gasto.iva;
	}

	onSubmit() {
		this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar el gasto?").then(
			res => {
				this.setValuePagos();
				//this.compra.
				this.gasto.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")

				
				this.gasto.detalle = this.gastos;
				this.gasto.pagos.push(this.pago);
				this.gasto.usuario_id = this.ss.getData('usuario_id');
				this.gasto.empresa_id = this.ss.getData('empresa_id');
				this.gasto.sucursal_id = this.ss.getData('sucursal_id');
				this.gasto.proveedor_id = this.proveedor.id;
				this.gasto.asignacion_caja_id = this.asignacion_id.toString();

				let data = {
					'compra': this.gasto,
				};

				this.loading = true;
		
				this.GastoService.save(this.gasto).subscribe(
					res => {
						this.gasto = new Gasto();
						this.proveedor = new Proveedor();
						this.pago = new Pago();
						
						this.cheques = [];
						this.tarjetas = [];
						this.valorefectivo = 0;
						this.transferencias = [];

						this.datosPagos.total_cheque = 0;
                        this.datosPagos.total_tarjeta = 0;
                        this.datosPagos.total_efectivo = 0;
                        this.datosPagos.total_transferencia = 0;
				
						this.gastos = [];
						this.total_pago = 0;
						//this.onIniDate();
						
						this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente - CAMBIO: ' + numeral(this.cambio).format("0,0.00"));
						this.cambio = 0;
						this.loading = false;

					},
					err => {
						this.loading = false;
						this.msgSweet.showMessage('error-message', err);
					}
				);
			}
		);
	}

	setValuePagos(){
		this.pago.detalle = [];
		this.pago.fecha_pago = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.pago.saldo = this.gasto.total;
        this.pago.recibido = this.total_pago;
        this.pago.cambio = this.cambio;
        //this.pago.compra_id = this.compra.id;
        this.pago.detalle = [];
        //this.pago.caja_id = this.ss.getData("caja_id");
        this.pago.empresa_id = this.ss.getData("empresa_id");
        this.pago.sucursal_id = this.ss.getData("sucursal_id");
		this.pago.usuario_id = this.ss.getData("usuario_id");
		
		if( this.valorefectivo > 0 ){
            let pago_detalle = new PagoDetalle();
            pago_detalle.valor = this.valorefectivo;
            pago_detalle.forma_pago_id = "1"; // EFECTIVO
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        }

        this.cheques.forEach(ch => {
            let pago_detalle = new PagoDetalle();

            pago_detalle.fecha_cheque = ch.fecha;
            pago_detalle.numero_cta = ch.cuenta;
            pago_detalle.numero_cheque = ch.numero;
            pago_detalle.banco_id = ch.banco_id;
            pago_detalle.observacion = ch.observacion;

            pago_detalle.valor = ch.valor;
            pago_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
        });

        this.tarjetas.forEach(tr => {
            let pago_detalle = new PagoDetalle();

            pago_detalle.debito_credito = tr.debito_credito;
            pago_detalle.observacion = tr.observacion;
            pago_detalle.tipo_tarjeta_id = tr.tipo_id;
			pago_detalle.valor = tr.valor;
			pago_detalle.plazo = tr.plazo;
            pago_detalle.tiempo = tr.tiempo;
            pago_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            pago_detalle.empresa_id = this.ss.getData("empresa_id");
            pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
            pago_detalle.usuario_id = this.ss.getData("usuario_id");
            this.pago.detalle.push(pago_detalle);
		});
		
		this.transferencias.forEach(tr => {
			let pago_detalle = new PagoDetalle();
	
			pago_detalle.fecha_transferencia = tr.fecha;
			pago_detalle.numero_cta = tr.cuenta;
			pago_detalle.numero_comprobante = tr.numero;
			pago_detalle.banco_id = tr.banco_id;
			pago_detalle.observacion = tr.observacion;
	
			pago_detalle.valor = tr.valor;
			pago_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
			pago_detalle.empresa_id = this.ss.getData("empresa_id");
			pago_detalle.sucursal_id = this.ss.getData("sucursal_id");
			pago_detalle.usuario_id = this.ss.getData("usuario_id");
			this.pago.detalle.push(pago_detalle);
		});
	}

	calcularTotal(total){
        this.total_pago = total;

        //CALCULAR CAMBIO
        let saldo = this.gasto.total - this.gasto.abonado;

        if( this.gasto.retencion ){
            saldo = saldo - this.gasto.retencion.total;
        }

        this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
        this.cambio = Math.round( this.cambio * 100) / 100;
	}
	
	onChangeEfectivo(total){
        this.valorefectivo = total;
	}

	onAperturaCaja(){
        return new Promise((resolve, reject) => {
            let qs = "?usuario_id=" + this.ss.getData('usuario_id');
            this.asignacionService.getAsignacion(qs).subscribe(
                res => {
                    if( res['tipo'] == 'A' ){
                        this.asignacion_id = res['id'];
                        this.onCaja(res['caja_id']).then(
                            res => resolve(),
                            err => reject(err),
                        );
                    }else{
                        const initialState = { caja_id: 0 };
                        this.bsModalRef = this.modalService.show(AperturaCajaModalComponent, Object.assign({backdrop: 'static'}, {initialState}));

                        this.bsModalRef.content.action.take(1).subscribe((caja_id) => {
                            //this.onCaja(caja_id);

                            let qs = "?usuario_id=" + this.ss.getData('usuario_id');
                            this.asignacionService.getAsignacion(qs).subscribe(
                                res => {
                                    if (res['tipo'] == 'A') {
                                        this.asignacion_id = res['id'];
                                        this.onCaja(res['caja_id']).then(
                                            res => resolve(),
                                            err => reject(err),
                                        );
                                    }else{
                                        resolve();
                                    }
                                },
                                err => {
                                    reject(err);
                                }
                            );
                        });

                        resolve();
                    }
                },
                err => {
                    reject(err);
                }
            );
        });
	}
	
	onCaja($id){
        return new Promise((resolve, reject) => {
            this.cajaService.getById($id).subscribe(
                res => {
                    this.caja = res;
                    resolve();
                },
                err => {
                    reject(err);
                }
            );
        });
	}
	
	onCierreCaja(){
        const initialState = { asignacion_id: this.asignacion_id , Respuesta:false };
        this.bsModalRef = this.modalService.show(CierreCajaModalComponent, Object.assign({backdrop: 'static'}, {initialState}));

        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
            if(Respuesta == true){
                this.caja = new Caja();
                this.onAperturaCaja();
            }
        });
    }

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/gasto-add/gasto-add.component.ts